import React, { useState } from "react";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import { useGetClientsQuery } from "../../../redux/service/modules/admin";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import ClientDetailDialog from "./ClientDetailDialog";
import Sectors from "../../../components/table/Sectors";
const ClientDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);

    const customCellRender = {
        sector_name: (row) => {
            return <Sectors sectors={row?.sector_name || []} maxVisible={2} />;
        },
    };

    return (
        <Layout>
            <CustomAdminLayout
                title={"Client Details"}
                createButtonText={"Add New Client"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Clients"}
            >
                <PaginatedDataTable
                    queryHook={useGetClientsQuery}
                    title="Client Management"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={true}
                    appliedFilters={{ search: searchText }}
                    dialogType={"client"}
                    customCellRender={customCellRender}
                />
                <ClientDetailDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Client"}
                    ctaText={"ADD CLIENT"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default ClientDetails;
